import React from 'react'
import './Contact.css'

const Contact = () => {
  return (
    <div>
        <h1>CONTACT</h1>

        <a className="contact" href="mailto:valentinbruhiere@pm.me">valentinbruhiere@pm.me</a>
        <p className="contact">06-59-52-10-91</p>
    </div>
  )
}

export default Contact